(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["assembly-products"]) return;
  try {
    
    const assemblyProductSlider = new Swiper('.assembly-products__container-mobile', {
      slidesPerView: 2,
      loop: true,
      centeredSlides: true
    });

  const assemblySlider = new Swiper('.assembly-instructions__steps-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      nextEl: '.assembly-instructions__buttons .swiper-button-next',
      prevEl: '.assembly-instructions__buttons .swiper-button-prev',
    }
  });

  $('.assembly-products__item').off().click(function() {
    var product = $(this).data('product');
    var idx = Number($(this).data('idx'));

    $('.assembly-products__item').removeClass('active');
    $(this).addClass('active');

    $('.assembly-instructions__product').removeClass('active');
    $(`.assembly-instructions__product[data-product="${product}"]`).addClass('active');

    $('.assembly-instructions__video').removeClass('active');
    $(`.assembly-instructions__video[data-product="${product}"]`).addClass('active');

    assemblyProductSlider.slideToLoop(idx)
  });

  /* assemblyProductSlider.on('slideChange', function (slider) {
    var idx = slider.realIndex;
    
    $('.assembly-products__item').removeClass('active');
    $(`.assembly-products__item[data-idx="${idx}"]`).addClass('active');

    $('.assembly-instructions__product').removeClass('active');
    $(`.assembly-instructions__product[data-idx="${idx}"]`).addClass('active');

    $('.assembly-instructions__video').removeClass('active');
    $(`.assembly-instructions__video[data-idx="${idx}"]`).addClass('active');
  });  */

  $('.assembly-instructions__video-overlay').click(function() {
    $(this).hide();
    $(this).siblings('video').trigger('play');
  });

  $('.btn, .assembly-products__item').click(function() {
    var targetElement = $('.assembly-instructions__product.active');
    var targetOffset = targetElement.offset().top - ($(window).height() / 2) + (targetElement.outerHeight() / 2);
    
    $('html, body').animate({
      scrollTop: targetOffset
    }, 800);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choose-nursery-seating-v2"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.choose-nursery-seating .toggle-button').forEach(button => {
      button.addEventListener('click', function() {
        const subElement = this.closest('.nursery-seating-sub');
        subElement.classList.toggle('active');
        
        const isVisible = subElement.classList.contains('active');
        this.innerHTML = isVisible ? `SHOW LESS <span>-</span>` : `READ MORE <span>+</span>`;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choose-nursery-seating"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.choose-nursery-seating .toggle-button').forEach(button => {
      button.addEventListener('click', function() {
        const subElement = this.closest('.nursery-seating-sub');
        subElement.classList.toggle('active');
        
        const isVisible = subElement.classList.contains('active');
        this.innerHTML = isVisible ? `SHOW LESS <span>-</span>` : `READ MORE <span>+</span>`;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"]) return;
  try {
    
  var headerHeight = $('.sticky-header').outerHeight();
  var barHeight = $('.collection-list__bar').outerHeight();

  $(window).scroll(function() {
    $('.collection-list__item').each(function(i, el) {
      if ($(el).offset().top - headerHeight - 2 - barHeight < $(window).scrollTop()) {
        var filter = $(el).data('filter');
        
        $('.collection-list__bar-filter').removeClass('active');
        $(`.collection-list__bar-filter[data-filter="${filter}"]`).addClass('active');
      }
    });
  });

  $('.collection-list__bar-filter').click(function() {
    var filter = $(this).data('filter');

    $([document.documentElement, document.body]).animate({
        scrollTop: $(`.collection-list__item[data-filter="${filter}"]`).offset().top - headerHeight - barHeight
    }, 2000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-slider"] && !window.DesignMode) return;
  try {
    
  var featuredProductSlider = new Swiper('.featured-product-slider__slider', {
    spaceBetween: 20,
    loop: false,
    breakpoints: {
      769: {
        navigation: {
          nextEl: '.featured-product-slider__slider-wrapper .swiper-button-next',
          prevEl: '.featured-product-slider__slider-wrapper .swiper-button-prev',
        },
        spaceBetween: 20,
        loop: true,
      }
    }
  });

  // Mobile tabs
  const featuredProductTabSlider = new Swiper('.featured-product-slider__mobile-tabs', {
    slidesPerView: 2.2,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    thumbs: {
      swiper: featuredProductSlider,
    },
  }); 

  featuredProductSlider.on('slideChange', function (slider) {
    var idx = slider.realIndex;

    featuredProductTabSlider.slideTo(idx);
  });

  $('.featured-product-slider__tab').click(function() {
    if (!$(this).hasClass('active')) {
      var tab = $(this).data('tab');

      $('.featured-product-slider__tab').removeClass('active');
      $(this).addClass('active');

      featuredProductSlider.slideTo(tab);
    }
  });

  featuredProductSlider.on('slideChange', function (swiper) {
    $('.featured-product-slider__tab').removeClass('active');
    $(`.featured-product-slider__tab[data-tab="${swiper.realIndex + 1}"]`).addClass('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $('.footer-block__heading').click(function() {
    if ($(window).width() < 769) {
      $(this).toggleClass('active');
      $(this).siblings('.footer-block__details-content-container').slideToggle(300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-plus-features"] && !window.DesignMode) return;
  try {
    

$(document).ready(function () {
  const pressQuotesSlider = new Swiper('.icon-features__container', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: '.icon-features .swiper-pagination'
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        allowTouchMove: false,
      }
    }
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-content"] && !window.DesignMode) return;
  try {
    
  var contentReviewsSlider = new Swiper('.image-content__reviews-slider', {
    spaceBetween: 20,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.image-content .swiper-pagination',
      clickable: true,
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !window.DesignMode) return;
  try {
    
  var instagramSlider = new Swiper('.instagram__slider', {
    slidesPerView: 1.5,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.instagram .swiper-button-next',
        prevEl: '.instagram .swiper-button-prev',
      },
    breakpoints: {
      1000: {
        slidesPerView: 2.6,
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: '.instagram .swiper-button-next',
          prevEl: '.instagram .swiper-button-prev',
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  if (getCookie('legalCookie')){
    $('.legal-popup').fadeOut(400);
  } else{
    $('.legal-popup').fadeIn(400);
  }

  document.querySelector('.cookie-container').addEventListener('click', () => {
    if ( document.querySelector('.cookie-heading').classList.contains('hidden') ) {
      document.querySelector('.cookie-heading').classList.remove('hidden');
      document.querySelector('.cookie-container').classList.add('expanded-coookie');
    } else {
      document.querySelector('.legal-popup__container').classList.remove('hidden');
      document.querySelector('.legal-popup').classList.add('active');
            document.querySelector('.cookie-container').classList.remove('expanded-coookie');
      document.body.classList.add('overflow-hidden');
    }
  });

  document.querySelector('.popup-close').addEventListener('click', () => {
    document.querySelector('.legal-popup__container').classList.add('hidden');
    document.querySelector('.cookie-heading').classList.add('hidden');
    document.querySelector('.cookie-container').classList.remove('expanded-coookie');
    document.querySelector('.legal-popup').classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  });
  
  $('.legal-popup__close').click(function () {
    var day = $('.legal-popup').attr('data-day');

    $('.legal-popup').fadeOut(400);
    document.querySelector('.legal-popup').classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    setCookie('legalCookie', true, day)
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-testimonial-section-v2"] && !window.DesignMode) return;
  try {
    
  const testimonial_Slider = new Swiper('.lp-testimonials-section-v2 .testimonial-slider__container', {
    slidesPerView: 1.4,
    loop: true,
    spaceBetween: 0,
    centeredSlides: true,
    spaceBetween: 15,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 16
      },
      1200: {
        slidesPerView: 3,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-testimonial-section"] && !window.DesignMode) return;
  try {
    
const testimonial_Slider = new Swiper('.lp-testimonials-section .testimonial-slider__container', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 0,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 34
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundle"]) return;
  try {
    
  // Initialize Slider
  const pdpSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  window.pdpSlider = pdpSlider;

  // On thumbnail click
  if (Array.isArray(pdpSlider)) {
    pdpSlider.forEach(slider => {
      slider.$el.on('click', '.product__slider-thumbnail-item', function() {
        var idx = $(this).data('slideid');
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        slider.slideToLoop(idx);
      });
    })
  } else {
    $('.product').on('click', '.product__slider-thumbnail-item', function() {
      var idx = $(this).data('slideid');

      $('.product__slider-thumbnail-item').removeClass('active');
      $(this).addClass('active');

      pdpSlider.slideToLoop(idx); 
    });
  }

  // On slide change
  if (Array.isArray(pdpSlider)) {
    pdpSlider.forEach(slider => {
      slider.on('slideChange', function (swiper) {
        var idx = swiper.realIndex;
        $(swiper.el).find('.product__slider-thumbnail-item').removeClass('active');
        $(swiper.el).find(`.product__slider-thumbnail-item[data-slideid="${idx}"]`).addClass('active');
      });
    })
  } else {
    pdpSlider.on('slideChange', function (slider) {
      var idx = slider.realIndex;
      $('.product__slider-thumbnail-item').removeClass('active');
      $(`.product__slider-thumbnail-item[data-slideid="${idx}"]`).addClass('active');
    });
  }

  // Dropdowns
  $('.product__dropdown-header').click(function() {
    $(this).toggleClass('active');
    $(this).siblings('.product__dropdown-content').slideToggle(400);
  });

  // Main Bundle Product Alternatives
  $('.product-bundle__group-tab').on('click', function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    let idx = $(this).index();
    let item = $(this).closest('.product-bundle__group').find('.product-bundle').get(idx);
    let announcement = $(this).closest('.product-bundles').find('.product-bundles__save').get(idx);
    $(item).siblings().addClass('hidden');
    $(item).removeClass('hidden');
    $(announcement).siblings().addClass('hidden');
    $(announcement).removeClass('hidden');

    $(document).trigger('bundle:updated');
  });

  // Bundle Variant Selection
  $('.product-bundle input[type="radio"]').change(function() {
    let $bundleOptions = $(this).closest('.product-bundle__options');
    let $activeOption = $bundleOptions?.find('.product-form__variant-active p');
    $activeOption?.text(this.value);
    
    $(document).trigger('bundle:updated');
  });

  $('.product-bundle modal-opener').click(function() {
    let $bundle = $(this).closest('.product-bundle__wrapper');
    let $selectedVariant = $bundle?.find('input[type="radio"]:checked');
    let $modal = $($(this).data('modal'));
    $modal?.find(`.product-bundle__options input[type="radio"][data-id="${$selectedVariant.data('id')}"]`).prop('checked', true);
    $modal?.find('.product-form__variant-active p').text($selectedVariant.val());
  });

  $('.product-bundle__modal-submit').click(function() {
    let $modal = $(this).closest('.product-bundle__modal');
    let $selectedVariant = $modal.find('input[type="radio"]:checked');
    let $bundle = $modal.siblings('.product-bundle__wrapper');
    $bundle?.find(`.product-bundle__options input[type="radio"][data-id="${$selectedVariant.data('id')}"]`).prop('checked', true);
    $bundle?.find('.product-form__variant-active p').text($selectedVariant.val());
    $modal.trigger('click');

    $(document).trigger('bundle:updated');
  });

  $(document).on('bundle:updated', function() {
    // update bundle price & ATC button price
    let price = 0;
    let compare_at_price = 0;
    let $price = $('.product__price-main .price');
    $('.product-bundle:not(.hidden)').each(function() {
      let $price = $(this).find('.product-bundle__wrapper .price');
      let p = $price.data('price');
      let cp = $price.data('compare-price');
      price += p;
      compare_at_price += cp ? cp : p;
    });
    if (price == compare_at_price) {
      $price.removeClass('price--on-sale');
      $price.find('.price__regular .price-item--regular').text(Shopify.formatMoney(price));
    } else {
      $price.addClass('price--on-sale');
      $price.find('.price__sale .price-item--regular').text(Shopify.formatMoney(compare_at_price));
      $price.find('.price__sale .price-item--sale').text(Shopify.formatMoney(price));
      $price.find('.price__badge-sale').text(Shopify.formatMoney(compare_at_price - price, '${{amount_no_decimals}}') + ' off');
    }
    $('.product-form__submit').find('span').remove()
    let atcLabel = $('.product-form__submit').html()
    $('.product-form__submit').html(`<span class="atcLabel">${atcLabel}</span>` + `<span class="normal-price">&nbsp;·&nbsp;${Shopify.formatMoney(price)}</span>`);
  });

  // Initialize the prices
  $(document).trigger('bundle:updated');

  window.addEventListener('load', function () {
    // Bundle Variant Image Update
    let variantDots = document.querySelectorAll('.product-bundle');
    variantDots.forEach(variant => {
      let variantRadioOptions = variant.querySelectorAll('.product-bundle__info .product-bundle__options .product-form__variant-list input');
      let variantImages = variant.querySelectorAll('.pdp--bundle-image .product-bundle__image');
      variantRadioOptions.forEach(radio => {
        if(radio.checked) {
          let radioId = radio.dataset.id;
          radio.parentNode.parentNode.querySelector('.product-form__variant-active').setAttribute('data-id', radio.getAttribute('data-id'))
          variantImages.forEach(img => {
            let imgId = img.dataset.id;
            if (radioId == imgId) {
              img.classList.add('display');
            } else if(img.classList.contains('display')) {
              img.classList.remove('display');
            }
          })
        }
        radio.addEventListener('change', (event) => {
          radio.parentNode.parentNode.querySelector('.product-form__variant-active').setAttribute('data-id', radio.getAttribute('data-id'))
          let newRadioId = radio.dataset.id;
          let badgeImg = radio.closest('.product-bundle').querySelector('.item-discount__badge');
          let discountAmount = event.target.getAttribute('data-discount-amount');
          let generalInput = radio.closest('.product-bundle').querySelector('.product-input__selector');
          const comparePrice = event.target.getAttribute('data-compare-price');
          const price = event.target.getAttribute('data-price');
          if(discountAmount && badgeImg) {
            badgeImg.innerText = '$'+discountAmount + ' OFF';
            generalInput.setAttribute('data-savings', discountAmount);
            generalInput.setAttribute('data-discount', discountAmount);
            badgeImg.classList.remove('hidden');
          } else if(badgeImg) {
            badgeImg.classList.add('hidden');
            generalInput.setAttribute('data-savings', discountAmount);
            generalInput.setAttribute('data-discount', discountAmount);
          }
          variantImages.forEach(img => {
            let imgId = img.dataset.id;
            if (newRadioId == imgId) {
              img.classList.add('display');
            } else if(img.classList.contains('display')) {
              img.classList.remove('display');
            }
          })
          getBundleSaveValue();
          if(document.querySelector('.bundle-builder__categories')) {
            radio.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.price-stock__wrapper .variant-price').innerHTML = '$' + radio.getAttribute('data-price');
          }
          if(variant.querySelector('.product-input__selector').checked) {
            variant.querySelector('.product-input__selector').click();
          }
          if((comparePrice === price) || !comparePrice) {
              radio.closest('.product-bundle').querySelector('.price-stock__wrapper .variant-price-final').innerHTML = '$' + price;
              radio.closest('.product-bundle').querySelector('.price-stock__wrapper .variant-price-crossed').classList.add('hidden');
          } 
          else {
            radio.closest('.product-bundle').querySelector('.price-stock__wrapper .variant-price-final').innerHTML = '$' + price;
            radio.closest('.product-bundle').querySelector('.price-stock__wrapper .variant-price-crossed').innerHTML = '$' + comparePrice;
            radio.closest('.product-bundle').querySelector('.price-stock__wrapper .variant-price-crossed').classList.remove('hidden');
          }
          let badge = radio.closest('.product-bundle').querySelector('.in-stock');
          let badgeText = radio.getAttribute('data-badge');
          if (badge && badgeText) {
              badge.innerText = badgeText;
          }
        })
      })
    })
  })
  // Bundle save value
  let bundleSave = document.querySelectorAll('.product-bundle__group-tabs .product-bundle__group-tab');
  bundleSave.forEach(tab => { 
    tab.addEventListener('click', ()=> {
      getBundleSaveValue();
    })
  })
  // Modal Select btn update
  let allModalDialogs = document.querySelectorAll('modal-dialog');
  allModalDialogs.forEach(modalPop => {
    let modalDialogId = modalPop.id.replace('BundleModal-', '')
    let modalDialogInput = modalPop.querySelectorAll('input[type="radio"]');
    let modalDialogGallery = modalPop.querySelectorAll('.product__variant-item');
    modalDialogInput.forEach(modalInput => {
      modalInput.addEventListener('change', ()=> {
        let modalId = modalInput.dataset.id;
        modalDialogGallery.forEach(gallery => {
          let galleryId = gallery.dataset.id;
          if (modalId == galleryId) {
            gallery.classList.add('display');
          } else if(gallery.classList.contains('display')) {
            gallery.classList.remove('display');
          }
        })
        let variantBundles = document.querySelectorAll('.product-bundle__wrapper');
        variantBundles.forEach(bundle => {
          let bundleId = bundle.dataset.id;
          if(modalDialogId == bundleId) {
            let bundleVariantImages = bundle.querySelectorAll('.product-bundle .pdp--bundle-image .product-bundle__image');
            bundleVariantImages.forEach(img => {
              let modalRadioId = modalInput.dataset.id;
              let imgId = img.dataset.id;
              if (modalRadioId == imgId) {
                img.classList.add('display');
              } else if(img.classList.contains('display')) {
                img.classList.remove('display');
              }
            })

          }
        })
        getBundleSaveValue();
      })
    })
  })
  let modalSelectBtn = document.querySelectorAll('.product-bundle__modal-submit');
  modalSelectBtn.forEach(modalBtn => {
    modalBtn.addEventListener('click', ()=> {
      getBundleSaveValue();
    })
  })
  getBundleSaveValue();

  // Get Bundle Save Value - update
  function getBundleSaveValue() {
    if(!document.querySelector('.bundle-builder__categories')) {
      let bundleSaveValue = document.querySelector('.product-bundles__save:not(p.hidden) b');
      let bundleSavePill = document.querySelector('#pdp--bundle-badge');
      //bundleSavePill.innerText = bundleSaveValue.innerText;
      // Button text
      let bundleDiscount = Number(bundleSavePill.innerText.replace(/[^0-9.-]+/g,"")) * 100;
      let bundleBtn = document.querySelector('.product--bundle .product-form__submit');
      let btnSpanATC = bundleBtn.querySelector('span.atcLabel');
      btnSpanATC.innerText = 'Add to Cart'
      let bundleBtnSpan = document.querySelector('.product--bundle .product-form__submit .normal-price');
      bundleBtnSpan.style.textDecoration = 'line-through';
      let bundleBtnPrice = Number(bundleBtnSpan.innerText.replace(' · ', '').replace(/[^0-9.-]+/g,"")) * 100;
      bundleBtnSpan.innerHTML = '';
      bundleBtnSpan.innerText = ` ${Shopify.formatMoney(bundleBtnPrice)}`;
      let finalPrice = bundleBtnPrice - bundleDiscount;
      let newPriceSpan = document.createElement('span');
      newPriceSpan.classList.add("discounted-price");
      newPriceSpan.innerText = ` ${Shopify.formatMoney(finalPrice)}`;
      bundleBtn.append(newPriceSpan);
      // Main Price
      let priceContainer = document.querySelector('.sh2 .price__sale');
      priceContainer.style.display = 'flex';
      let priceItemSale = document.querySelector('.sh2 .price__sale .price-item.price-item--sale');
      let priceItemRegular = document.querySelector('.sh2 .price__sale .price-item.price-item--regular');
      priceItemSale.innerText = `${Shopify.formatMoney(finalPrice)}`;
      priceItemRegular.innerText = `${Shopify.formatMoney(bundleBtnPrice)}`;
      priceItemRegular.style.opacity = '0.5';
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${type}`,
      },
    };
  }

  let product = document.querySelector('.product.product_container');
  let sectionId = product.dataset.section;
  let queryString = window.location.search;
  let searchParams = new URLSearchParams(queryString);
  let variant = searchParams.get('variant');
  if (variant) {
    let variantSelected = document.querySelector(`.variant${variant}.product-variant-option`);
    variantSelected?.setAttribute('checked', 'checked');
  } else {
    let variantSelected = document.querySelector(`#${sectionId}-product-variant-0`);
    variantSelected?.setAttribute('checked', 'checked');
  }

  $('.upgrade__atc').click(function () {
    let id = Number($(this).parent().find('.upgrade-swatch.selectedColor').data('varid'));
    const sectionsToRender = [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];

    const body = JSON.stringify({
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
      sections: sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    document.querySelector('.discount-announcements-heading')?.classList.add('hidden');
    document.querySelector('.discount-announcements-heading-discount-applied')?.classList.add('hidden');
    document.querySelector('.discount-announcements-heading-updating-discounts')?.classList.remove('hidden');

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        sectionsToRender.forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });
        document.querySelector('cart-drawer').createRecommendedProductsList();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector('cart-drawer').open();
        typeof window.updateDiscountAnnouncements === 'function' && window.updateDiscountAnnouncements();
      });
  });

  let productItem = {};
  let variantItems = {};

  // CUSTOM CART
  function getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
  //
  //Calculate button price

  //

  //Set button price with discounts
  let discountMoneyParentGlobal = document.querySelector('.price-item.price-item--sale');
  let discountMoneyTextGlobal = discountMoneyParentGlobal?.firstElementChild?.textContent;
  if (discountMoneyTextGlobal) {
    let productPrice = discountMoneyTextGlobal?.replace('$', '');
    let buttonMoneyPrice = document.querySelector('#buttonMoneyPrice');
    buttonMoneyPrice.textContent = productPrice;
  }

  // COMPLETE THE SET
  let upgradeOptions = document.getElementsByClassName('upgrade-dropdown-option');
  for (option of upgradeOptions) {
    let product = option.dataset.product;
    let noneproducta = option.dataset.nonea;
    let noneproductb = option.dataset.noneb;
    let noneproductc = option.dataset.nonec;
    let variant = option.dataset.variant;
    let selectedPKey = option.dataset.pkey;
    let objectString = option.dataset.text;
    let { title, price } = JSON.parse(objectString);
    let itemId = option.id;

    option.addEventListener('click', () => {
      if (noneproducta) {
        delete variantItems[noneproducta];
      }
      if (noneproductb) {
        delete variantItems[noneproductb];
      }
      if (noneproductc) {
        delete variantItems[noneproductc];
      }
      if (variant !== 'none') {
        variantItems[product] = variant;
      }
      let dpHeader = document.querySelector('.product__dropdown-header.' + selectedPKey);
      let selectedlist = document.querySelector('.dropdown.' + selectedPKey);
      let selectedtext = document.querySelector('.selectorText.' + selectedPKey);
      let arrowIcon = document.querySelector('.arrowIcon.' + selectedPKey);
      let priceText = document.querySelector('.priceText.' + selectedPKey);
      let check = document.querySelector('.check.' + selectedPKey + '.select' + itemId);
      let selectorChecks = document.querySelectorAll('.check.' + selectedPKey);
      for (selectorCheck of selectorChecks) {
        if (!selectorCheck.classList.contains(`select${itemId}`)) {
          selectorCheck.classList.add('hide');
        }
      }
      //dpHeader.classList.remove('active');
      check.classList.toggle('hide');
      if (check.classList.contains('hide')) {
        variantItems[product] = variant;
      }
      //selectedlist.classList.toggle('hide-dropdown');
      arrowIcon.classList.toggle('rotate');
      selectedtext.textContent = title;
      priceText.textContent = price;
      selectedtext.classList.remove('firstText');
      calculateButtonPrice();
    });
    p++;
  }
  //

  //POST ADD TO CART
  function addAllItems() {
    let items = [];
    let body = {};
    let quantityInput = document.querySelector('.quantity__input.btn.quantity_of_product');
    let addons = document.querySelectorAll('.customize-product.customize-product--active');
    Object.keys(variantItems).forEach(function (key, index) {
      items.push({ id: variantItems[key], quantity: parseInt(quantityInput.value) });
    });
    Object.keys(addons).forEach(function (key, index) {
      items.push({
        id: addons[key].getAttribute('data-selected-variant'),
        quantity: parseInt(addons[key].getAttribute('data-quantity')),
      });
    });
    Object.keys(productItem).forEach(function (key, index) {
      items.push({ id: productItem[key], quantity: parseInt(quantityInput.value) });
    });
    body = {
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
      items: items,
    };

    document.querySelector('.discount-announcements-heading')?.classList.add('hidden');
    document.querySelector('.discount-announcements-heading-discount-applied')?.classList.add('hidden');
    document.querySelector('.discount-announcements-heading-updating-discounts')?.classList.remove('hidden');

    fetch(`/cart/add.js`, {
      body: JSON.stringify(body),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      method: 'POST',
    })
      .then((response) => response.json())
      .then((parsedState) => {
        getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          document.querySelector('cart-drawer').createRecommendedProductsList();
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        productItem = {};
        document.querySelector('cart-drawer').open();
        typeof window.updateDiscountAnnouncements === 'function' && window.updateDiscountAnnouncements();
      });
  }
  //

  //HANDLE FINAL ADD TO CART
  //var addToCart = document.getElementById('final-add-to-cart');
  let ATCs = document.querySelectorAll('.buttonAddToCart');
  ATCs.forEach((addToCart) => {
    addToCart.addEventListener('click', function handleAddToCart(e) {
      if(document.querySelectorAll('.customize-product--active').length > 0) return;
      const flyOutContainer = e.target.closest('.fly-out-product-card-container');
      let selectedVariantElement;
      let defaultVariantElement;
      if ( flyOutContainer ) {
        selectedVariantElement = flyOutContainer.querySelector('.product-variant-option:checked');
        defaultVariantElement = flyOutContainer.querySelector('.product-form__variant-list');
      } else if (e.target.closest('.product')) {
        selectedVariantElement = e.target.closest('.product').querySelector('.product-variant-option:checked');
        defaultVariantElement = e.target.closest('.product').querySelector('.product-form__variant-list');
      }
      else {
        selectedVariantElement = document.querySelector('.product').querySelector('.product-variant-option:checked');
        defaultVariantElement = document.querySelector('.product').querySelector('.product-form__variant-list');
      }
      let selectedVariant = selectedVariantElement?.dataset?.id || e.target?.dataset?.variant;
      if (selectedVariant) {
        productItem[e.target.dataset.product] = selectedVariant;
      }
      addAllItems();
    });
  });
  //

  // Initialize Slider
  const pdpSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  window.pdpSlider = pdpSlider;

  // On thumbnail click
  $('.product').on('click', '.product__slider-thumbnail-item', function () {
    var idx = $(this).data('slideid');

    $('.product__slider-thumbnail-item').removeClass('active');
    $(this).addClass('active');

    pdpSlider.slideToLoop(idx);
  });

  // On slide change
  pdpSlider.on('slideChange', function (slider) {
    var idx = slider.realIndex;

    $('.product__slider-thumbnail-item').removeClass('active');
    $(`.product__slider-thumbnail-item[data-slideid="${idx}"]`).addClass('active');
  });

  // Dropdowns
  $('.product__dropdown-header').click(function () {
    $(this).toggleClass('active');
    $(this).siblings('.product__dropdown-content').slideToggle(400);
  });

  //Incrase product quantity
  let incraseQuantityProductButton = document.querySelector('.quantity__button.plus');
  incraseQuantityProductButton.addEventListener('click', () => {
    calculateButtonPrice();
  });
  //decrease product quantity
  let decreaseQuantityProductButton = document.querySelector('.quantity__button.minus');
  decreaseQuantityProductButton.addEventListener('click', () => {
    calculateButtonPrice();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  if (getCookie('newsletterPopup')){
    $('.newsletter-popup').fadeOut(400);
    $('.page-overlay').removeClass('is-visible');
  } else{
    setTimeout(function() {
	  if ($('.newsletter-popup').length > 0) {
        $('.newsletter-popup').fadeIn(400);
        $('.page-overlay').addClass('is-visible');
      }
    }, 5000);
  }

  $('.newsletter-popup__close').click(function () {
    var day = 1;

    $('.newsletter-popup').fadeOut(400);
    $('.page-overlay').removeClass('is-visible');
    setCookie('newsletterPopup', true, day);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursery-glider-v2"] && !window.DesignMode) return;
  try {
    
  const nurseryGliderSlider = new Swiper('.nursery-glider-main .product-slider_container', {
    slidesPerView: 1.13,
    loop: false,
    allowTouchMove: true,
    spaceBetween: 10,
    breakpoints: {
      769: {
        slidesPerView: 3.3,
        spaceBetween: 15,
        watchOverflow: true
      },
    },
  });
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.nursery-glider-main .card-information__swatches.swatch-color button.active').forEach(function(button) {
      let color = button.getAttribute('data-value');
      let swatchColorParent = button.parentElement;
      let swatchTitle = swatchColorParent.querySelector('.swatch-title');
      if (swatchTitle) {
        swatchTitle.textContent = color;
      }
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursery-glider"] && !window.DesignMode) return;
  try {
    
  const nurseryGliderSlider = new Swiper('.nursery-glider-main .product-slider_container', {
    slidesPerView: 1.13,
    loop: false,
    allowTouchMove: true,
    spaceBetween: 10,
    breakpoints: {
      769: {
        slidesPerView: 3.3,
        spaceBetween: 15,
        watchOverflow: true
      },
    },
  });
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.nursery-glider-main .card-information__swatches.swatch-color button.active').forEach(function(button) {
      let color = button.getAttribute('data-value');
      let swatchColorParent = button.parentElement;
      let swatchTitle = swatchColorParent.querySelector('.swatch-title');
      if (swatchTitle) {
        swatchTitle.textContent = color;
      }
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main-top"] && !window.DesignMode) return;
  try {
    
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${type}`,
      },
    };
  }

  let product = document.querySelector('.product.product_container');
  let sectionId = product.dataset.section;
  let queryString = window.location.search;
  let searchParams = new URLSearchParams(queryString);
  let variant = searchParams.get('variant');
  if (variant) {
    let variantSelected = document.querySelector(`.variant${variant}.product-variant-option`);
    variantSelected?.setAttribute('checked', 'checked');
  } else {
    let variantSelected = document.querySelector(`#${sectionId}-product-variant-0`);
    variantSelected?.setAttribute('checked', 'checked');
  }

  $('.upgrade__atc').click(function () {
    let id = Number($(this).parent().find('.upgrade-swatch.selectedColor').data('varid'));
    const sectionsToRender = [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];

    const body = JSON.stringify({
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
      sections: sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    document.querySelector('.discount-announcements-heading')?.classList.add('hidden');
    document.querySelector('.discount-announcements-heading-discount-applied')?.classList.add('hidden');
    document.querySelector('.discount-announcements-heading-updating-discounts')?.classList.remove('hidden');

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        sectionsToRender.forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });
        document.querySelector('cart-drawer').createRecommendedProductsList()
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector('cart-drawer').open();
  typeof window.updateDiscountAnnouncements === 'function' && window.updateDiscountAnnouncements();
      });
  });
  

  let productItem = {};
  let variantItems = {};

  // CUSTOM CART
  function getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
  //
  //Calculate button price
  
  //

  //Set button price with discounts
  let discountMoneyParentGlobal = document.querySelector('.price-item.price-item--sale');
  let discountMoneyTextGlobal = discountMoneyParentGlobal?.firstElementChild?.textContent;
  if (discountMoneyTextGlobal) {
    let productPrice = discountMoneyTextGlobal?.replace('$', '');
    let buttonMoneyPrice = document.querySelector('#buttonMoneyPrice');
    buttonMoneyPrice.textContent = productPrice;
  }

  // COMPLETE THE SET
  let upgradeOptions = document.getElementsByClassName('upgrade-dropdown-option');
  for (option of upgradeOptions) {
    let product = option.dataset.product;
    let noneproducta = option.dataset.nonea;
    let noneproductb = option.dataset.noneb;
    let noneproductc = option.dataset.nonec;
    let variant = option.dataset.variant;
    let selectedPKey = option.dataset.pkey;
    let objectString = option.dataset.text;
    let { title, price } = JSON.parse(objectString);
    let itemId = option.id;

    option.addEventListener('click', () => {
      if (noneproducta) {
        delete variantItems[noneproducta];
      }
      if (noneproductb) {
        delete variantItems[noneproductb];
      }
      if (noneproductc) {
        delete variantItems[noneproductc];
      }
      if (variant !== 'none') {
        variantItems[product] = variant;
      }
      let dpHeader = document.querySelector('.product__dropdown-header.' + selectedPKey);
      let selectedlist = document.querySelector('.dropdown.' + selectedPKey);
      let selectedtext = document.querySelector('.selectorText.' + selectedPKey);
      let arrowIcon = document.querySelector('.arrowIcon.' + selectedPKey);
      let priceText = document.querySelector('.priceText.' + selectedPKey);
      let check = document.querySelector('.check.' + selectedPKey + '.select' + itemId);
      let selectorChecks = document.querySelectorAll('.check.' + selectedPKey);
      for (selectorCheck of selectorChecks) {
        if(!selectorCheck.classList.contains(`select${itemId}`)) {
          selectorCheck.classList.add('hide');
        }
      }
      //dpHeader.classList.remove('active');
      check.classList.toggle('hide');
      if (check.classList.contains('hide')) {
        variantItems[product] = variant;
      }
      //selectedlist.classList.toggle('hide-dropdown');
      arrowIcon.classList.toggle('rotate');
      selectedtext.textContent = title;
      priceText.textContent = price;
      selectedtext.classList.remove('firstText');
      calculateButtonPrice();
    });
    p++;
  }
  //

  //POST ADD TO CART
  function addAllItems() {
    let items = [];
    let body = {};
    let quantityInput = document.querySelector('.quantity__input.btn.quantity_of_product');
    let addons = document.querySelectorAll('.customize-product.customize-product--active');
    Object.keys(variantItems).forEach(function (key, index) {
      items.push({ id: variantItems[key], quantity: parseInt(quantityInput.value) });
    });
    Object.keys(addons).forEach(function (key, index) {
      items.push({ id: addons[key].getAttribute('data-selected-variant'), quantity: parseInt(addons[key].getAttribute('data-quantity')) });
    });
    Object.keys(productItem).forEach(function (key, index) {
      items.push({ id: productItem[key], quantity: parseInt(quantityInput.value) });
    });
    body = {
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
      items: items,
    };

    document.querySelector('.discount-announcements-heading')?.classList.add('hidden');
    document.querySelector('.discount-announcements-heading-discount-applied')?.classList.add('hidden');
    document.querySelector('.discount-announcements-heading-updating-discounts')?.classList.remove('hidden');

    fetch(`/cart/add.js`, {
      body: JSON.stringify(body),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      method: 'POST',
    })
      .then((response) => response.json())
      .then((parsedState) => {
        getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          document.querySelector('cart-drawer').createRecommendedProductsList()
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (typeof window.flyOutLoad === "function") {
            window.flyOutLoad(); // Safely call the function
          }
        productItem = {};
        document.querySelector('cart-drawer').open();
  typeof window.updateDiscountAnnouncements === 'function' && window.updateDiscountAnnouncements();
      });
  }
  //

  //HANDLE FINAL ADD TO CART
  //var addToCart = document.getElementById('final-add-to-cart');
  let ATCs = document.querySelectorAll('.buttonAddToCart');
  ATCs.forEach((addToCart) => {
    addToCart.addEventListener('click', function handleAddToCart(e) {
      const flyOutContainer = e.target.closest('.fly-out-product-card-container');
      let selectedVariantElement;
      let defaultVariantElement;
      if ( flyOutContainer ) {
        selectedVariantElement = flyOutContainer.querySelector('.product-variant-option:checked');
        defaultVariantElement = flyOutContainer.querySelector('.product-form__variant-list');
      } else {
        selectedVariantElement = e.target.closest('.product').querySelector('.product-variant-option:checked');
        defaultVariantElement = e.target.closest('.product').querySelector('.product-form__variant-list');
      }
      let selectedVariant = selectedVariantElement?.dataset?.id || e.target?.dataset?.variant;
      if (selectedVariant) {
        productItem[e.target.dataset.product] = selectedVariant;
      }
      addAllItems();
    });
  })
  //

  // Initialize Slider
  const pdpSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  window.pdpSlider = pdpSlider;

  // On thumbnail click
  $('.product').on('click', '.product__slider-thumbnail-item', function () {
    var idx = $(this).data('slideid');

    $('.product__slider-thumbnail-item').removeClass('active');
    $(this).addClass('active');

    pdpSlider.slideToLoop(idx);
  });

  // On slide change
  pdpSlider.on('slideChange', function (slider) {
    var idx = slider.realIndex;

    $('.product__slider-thumbnail-item').removeClass('active');
    $(`.product__slider-thumbnail-item[data-slideid="${idx}"]`).addClass('active');
  });

  // Dropdowns
  $('.product__dropdown-header').click(function () {
    $(this).toggleClass('active');
    $(this).siblings('.product__dropdown-content').slideToggle(400);
  });

  //Incrase product quantity
  let incraseQuantityProductButton = document.querySelector('.quantity__button.plus');
  incraseQuantityProductButton.addEventListener('click', () => {
    calculateButtonPrice();
  });
  //decrease product quantity
  let decreaseQuantityProductButton = document.querySelector('.quantity__button.minus');
  decreaseQuantityProductButton.addEventListener('click', () => {
    calculateButtonPrice();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-quotes"] && !window.DesignMode) return;
  try {
    
  const pressQuotesSlider = new Swiper('.press-quotes__container', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: '.press-quotes .swiper-pagination'
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        allowTouchMove: false,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !window.DesignMode) return;
  try {
    
  // Move main nav on scroll
  var topPoint = $('.product').offset().top + $('.product').outerHeight();
  var point = topPoint - $('.product-bar').outerHeight();

  $(window).scroll(function() {
    if ($(window).scrollTop() > point) {
      $('.sticky-header').css('transform', 'translateY(-100%)');
      $('.product-bar').addClass('active');
    } else {
      $('.sticky-header').css('transform', 'translateY(0)');
      $('.product-bar').removeClass('active');
    }
  });

  // Make links active on scroll
  var $links = $('.product-bar__nav-container button');
  var navHeight = $('.product-bar').outerHeight();
  $(window).scroll(function() {
    var fromTop = $(window).scrollTop();

    $links.each(function(i, link) {
      var sectionName = $(link).data('section');
      var $section = $(`.product-section[data-section="${sectionName}"]`);
      
      if (
        $section.length &&
        ($section.offset().top - navHeight) <= fromTop &&
        ($section.offset().top - navHeight) + $section.outerHeight() > fromTop
      ) {
        $(link).addClass('active');
      } else {
        $(link).removeClass('active');
      }
    });
  });

  // Scroll to link
  $('.product-bar__nav-container button').click(function(e) {
    e.preventDefault();
    var section = $(this).data('section');
    var $section = $(`.product-section[data-section="${section}"]`);

    if ($section.length) {
      $('html, body').animate({
        scrollTop: $section.offset().top - navHeight + 5
      }, 500);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !window.DesignMode) return;
  try {
    
  // Mobile Nav 
  const mobileNavSlider = new Swiper('.product-features__mobile-nav', {
    slidesPerView: 2.5,
    spaceBetween: 40,
    centeredSlides: true,
    slideToClickedSlide: true 
  });

  mobileNavSlider.on('slideChange', function (slider) {
    var idx = slider.activeIndex + 1;

    $('.product-features__nav-item').removeClass('active');
    $(`.product-features__nav-item[data-tab="${idx}"]`).addClass('active');

    $('.product-features__item').removeClass('active');
    $(`.product-features__item[data-num="${idx}"]`).addClass('active');
  });

  // Desktop Nav
  $('.product-features__nav-item').click(function() {
    var num = $(this).data('tab');

    $('.product-features__nav-item').removeClass('active');
    $(this).addClass('active');

    $('.product-features__item').removeClass('active');
    $(`.product-features__item[data-num="${num}"]`).addClass('active');

    // Mobile sync
    mobileNavSlider.slideTo(Number(num) - 1);
  });

  // Badge Sliders
  var sliderConfig = {
    effect: 'fade',
    loop: true,
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true
    }
  }

  // const featureBadgeSlider1 = new Swiper('.product-features__badge-groups--1', sliderConfig);
  // const featureBadgeSlider2 = new Swiper('.product-features__badge-groups--2', sliderConfig);
  // const featureBadgeSlider3 = new Swiper('.product-features__badge-groups--3', sliderConfig);
  
  const featureBadgeSlider = [];
  $('.product-features__badge-groups').each(function(idx) {
    let slider = new Swiper(this, sliderConfig);
    slider.on('slideChange', (swiper) => {
      $(swiper.$el).closest('.product-features__item').find('.product-features__feature').removeClass('active').filter(`[data-num="${swiper.realIndex + 1}"]`).addClass('active');
    });
    featureBadgeSlider.push(slider);
  });

  // Handle feature on click
  $('.product-features__feature').hover(function() { 
    var num = Number($(this).data('num'));
    var sliderNum = $(this).parent().parent().data('num');

    // $('.product-features__feature').addClass('tab-switch');
    $('.product-features__badge-group svg').addClass('feature-switch');
    // $('.product-features__image-container .product-image').addClass('tab-switch');

    /* if (sliderNum == 1) {
      featureBadgeSlider1.slideTo(num);
    } else if (sliderNum == 2) {
      featureBadgeSlider2.slideTo(num);
    } else if (sliderNum == 3) {
      featureBadgeSlider3.slideTo(num);
    } */
    featureBadgeSlider[sliderNum - 1].slideTo(num);

    $(this).parent().parent().find('.product-features__feature').removeClass('active');
    $(this).addClass('active');

    // $('.product-features__feature').removeClass('tab-switch');
    setTimeout(function() {
      $('.product-features__badge-group svg').removeClass('feature-switch');
    }, 800);
    // $('.product-features__image-container .product-image').removeClass('tab-switch');
  });

  // Mobile features sliders
  const mobileFeatureSlider = [];
  $('.product-features__item .product-features__mobile-slider').each(function(idx) {
    mobileFeatureSlider.push(new Swiper(this, {
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      thumbs: {
        swiper: featureBadgeSlider[idx]
      }
    }));
  });
  /*const mobileFeatureSlider1 = new Swiper('.product-features__item[data-num="1"] .product-features__mobile-slider', {
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.product-features__item[data-num="1"] .swiper-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: featureBadgeSlider1
    }
  });

  const mobileFeatureSlider2 = new Swiper('.product-features__item[data-num="2"] .product-features__mobile-slider', {
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.product-features__item[data-num="2"] .swiper-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: featureBadgeSlider2
    }
  });

  const mobileFeatureSlider3 = new Swiper('.product-features__item[data-num="3"] .product-features__mobile-slider', {
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.product-features__item[data-num="3"] .swiper-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: featureBadgeSlider3
    }
  });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-individual-slider-v2"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $(".product-slider-v2").each(function (idx) {
      let container = $(this).find(".product-slider__v2").get(0);
      let navNext = $(this).find(".swiper-button-next").get(0);
      let navPrev = $(this).find(".swiper-button-prev").get(0);
      new Swiper(container, {
        slidesPerView: 1.13,
        loop: true,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          769: {
            slidesPerView: 4,
            spaceBetween: 30,
            allowTouchMove: false,
            watchOverflow: true,
            arrow: true,
            navigation: {
              nextEl: navNext,
              prevEl: navPrev,
            },
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-individual-slider-v3"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $(".product-slider-v2").each(function (idx) {
      let container = $(this).find(".product-slider__v2").get(0);
      let navNext = $(this).find(".swiper-button-next").get(0);
      let navPrev = $(this).find(".swiper-button-prev").get(0);
      new Swiper(container, {
        slidesPerView: 1.13,
        loop: true,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          769: {
            slidesPerView: 4,
            spaceBetween: 30,
            allowTouchMove: false,
            watchOverflow: true,
            arrow: true,
            navigation: {
              nextEl: navNext,
              prevEl: navPrev,
            },
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              const productSlider = new Swiper('.product-recommendations__slider', {
                slidesPerView: 1.3,
                loop: true,
                spaceBetween: 8,
                watchOverflow: true,
                breakpoints: {
                  769: {
                    slidesPerView: 2.6,
                    spaceBetween: 16,
                    navigation: {
                      nextEl: '.product-recommendations__slider-wrapper .swiper-button-next',
                      prevEl: '.product-recommendations__slider-wrapper .swiper-button-prev',
                    },
                  },
                  991: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                  },
                  1440: {
                    slidesPerView: 5,
                    spaceBetween: 16,
                  },
                },
              });
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-room-v2"] && !window.DesignMode) return;
  try {
    

  // Shop the Room Slider
  const shopTheRoomSlider = new Swiper('.shop-the-room__rooms', {
    spaceBetween: 20,
    allowTouchMove: false,
  });

  // Shop the Room Tabs
  const shopTheRoomTabSlider = new Swiper('.shop-the-room__tabs', {
    slidesPerView: 1.6,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true, 
    thumbs: {
      swiper: shopTheRoomSlider,
    },
  });

  shopTheRoomTabSlider.on('slideChange', function (slider) {
    var idx = slider.realIndex + 1;
    $('.shop-the-room__mobile-products').removeClass('active');
    $(`.shop-the-room__mobile-products[data-num="${idx}"]`).addClass('active');
  });

  // Mobile Slider
  var shopTheRoomMobileSliderConfig = {
    slidesPerView: 1.15,
    spaceBetween: 20,
    loop: true,
    on: {
      slideChange: function (slider) {
		$(document).on("click",".shop-the-room__room-point-wrapper", function () {
          var idx = $(this).data('num')
          $('.shop-the-room__room-point-wrapper').removeClass('active');
          $(`.shop-the-room__room-point-wrapper[data-num="${idx}"]`).addClass('active');
		})
      },
    }
  }
  
  const shopTheRoomMobileSlider1 = new Swiper('.shop-the-room__mobile-products[data-num="1"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider2 = new Swiper('.shop-the-room__mobile-products[data-num="2"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider3 = new Swiper('.shop-the-room__mobile-products[data-num="3"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider4 = new Swiper('.shop-the-room__mobile-products[data-num="4"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider5 = new Swiper('.shop-the-room__mobile-products[data-num="5"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider6 = new Swiper('.shop-the-room__mobile-products[data-num="6"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider7 = new Swiper('.shop-the-room__mobile-products[data-num="7"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider8 = new Swiper('.shop-the-room__mobile-products[data-num="8"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider9 = new Swiper('.shop-the-room__mobile-products[data-num="9"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider10 = new Swiper('.shop-the-room__mobile-products[data-num="10"]', shopTheRoomMobileSliderConfig);

    $('.shop-the-room__room-point-wrapper').removeClass('active');
    $('.shop-the-room__room-point-wrapper[data-num="1"]').addClass('active');
  

  // Shop the Room Desktop Controls
  $('.shop-the-room__tabs-desktop .btn').click(function() {
    var tab = Number($(this).data('tab'));

    $('.shop-the-room__tabs-desktop .btn').removeClass('active');
    $(this).addClass('active');

    shopTheRoomSlider.slideTo(tab);
    shopTheRoomTabSlider.slideTo(tab);

    $('.shop-the-room__mobile-products').removeClass('active');
    $(`.shop-the-room__mobile-products[data-num="${tab}"]`).addClass('active');
  });

  $('.shop-the-room__room-point').click(function() {
    var num = $(this).parent().data('num');
    
    if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active');
        let handle = $(this).parent().data('handle')
        window.location.href = `/products/${handle}`;
    } else {
      $('.shop-the-room__room-point-wrapper').removeClass('active');
      $(this).parent().addClass('active');

      var parentNum = $(this).closest('.shop-the-room__room').data('num');
      if (parentNum == 1) {
        shopTheRoomMobileSlider1.slideTo(Number(num) + 1);
      } else if (parentNum == 2) {
        shopTheRoomMobileSlider2.slideTo(Number(num) + 1);
      } else if (parentNum == 3) {
        shopTheRoomMobileSlider3.slideTo(Number(num) + 1);
      } else if (parentNum == 4) {
        shopTheRoomMobileSlider4.slideTo(Number(num) + 1);
      } else if (parentNum == 5) {
        shopTheRoomMobileSlider5.slideTo(Number(num) + 1);
      } else if (parentNum == 6) {
        shopTheRoomMobileSlider6.slideTo(Number(num) + 1);
      } else if (parentNum == 7) {
        shopTheRoomMobileSlider7.slideTo(Number(num) + 1);
      } else if (parentNum == 8) {
        shopTheRoomMobileSlider8.slideTo(Number(num) + 1);
      } else if (parentNum == 9) {
        shopTheRoomMobileSlider9.slideTo(Number(num) + 1);
      } else if (parentNum == 10) {
        shopTheRoomMobileSlider10.slideTo(Number(num) + 1);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-room"] && !window.DesignMode) return;
  try {
    

  // Shop the Room Slider
  const shopTheRoomSlider = new Swiper('.shop-the-room__rooms', {
    spaceBetween: 20,
    allowTouchMove: false,
  });

  // Shop the Room Tabs
  const shopTheRoomTabSlider = new Swiper('.shop-the-room__tabs', {
    slidesPerView: 1.6,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true, 
    thumbs: {
      swiper: shopTheRoomSlider,
    },
  });

  shopTheRoomTabSlider.on('slideChange', function (slider) {
    var idx = slider.realIndex + 1;
    $('.shop-the-room__mobile-products').removeClass('active');
    $(`.shop-the-room__mobile-products[data-num="${idx}"]`).addClass('active');
  });

  // Mobile Slider
  var shopTheRoomMobileSliderConfig = {
    slidesPerView: 1.15,
    spaceBetween: 20,
    loop: true,
    on: {
      slideChange: function (slider) {
		$(document).on("click",".shop-the-room__room-point-wrapper", function () {
          var idx = $(this).data('num')
          $('.shop-the-room__room-point-wrapper').removeClass('active');
          $(`.shop-the-room__room-point-wrapper[data-num="${idx}"]`).addClass('active');
		})
      },
    }
  }
  
  const shopTheRoomMobileSlider1 = new Swiper('.shop-the-room__mobile-products[data-num="1"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider2 = new Swiper('.shop-the-room__mobile-products[data-num="2"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider3 = new Swiper('.shop-the-room__mobile-products[data-num="3"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider4 = new Swiper('.shop-the-room__mobile-products[data-num="4"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider5 = new Swiper('.shop-the-room__mobile-products[data-num="5"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider6 = new Swiper('.shop-the-room__mobile-products[data-num="6"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider7 = new Swiper('.shop-the-room__mobile-products[data-num="7"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider8 = new Swiper('.shop-the-room__mobile-products[data-num="8"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider9 = new Swiper('.shop-the-room__mobile-products[data-num="9"]', shopTheRoomMobileSliderConfig);
  const shopTheRoomMobileSlider10 = new Swiper('.shop-the-room__mobile-products[data-num="10"]', shopTheRoomMobileSliderConfig);

    $('.shop-the-room__room-point-wrapper').removeClass('active');
    $('.shop-the-room__room-point-wrapper[data-num="1"]').addClass('active');
  

  // Shop the Room Desktop Controls
  $('.shop-the-room__tabs-desktop .btn').click(function() {
    var tab = Number($(this).data('tab'));

    $('.shop-the-room__tabs-desktop .btn').removeClass('active');
    $(this).addClass('active');

    shopTheRoomSlider.slideTo(tab);
    shopTheRoomTabSlider.slideTo(tab);

    $('.shop-the-room__mobile-products').removeClass('active');
    $(`.shop-the-room__mobile-products[data-num="${tab}"]`).addClass('active');
  });

  $('.shop-the-room__room-point').click(function() {
    var num = $(this).parent().data('num');
    
    if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active');
        let handle = $(this).parent().data('handle')
        window.location.href = `/products/${handle}`;
    } else {
      $('.shop-the-room__room-point-wrapper').removeClass('active');
      $(this).parent().addClass('active');

      var parentNum = $(this).closest('.shop-the-room__room').data('num');
      if (parentNum == 1) {
        shopTheRoomMobileSlider1.slideTo(Number(num) + 1);
      } else if (parentNum == 2) {
        shopTheRoomMobileSlider2.slideTo(Number(num) + 1);
      } else if (parentNum == 3) {
        shopTheRoomMobileSlider3.slideTo(Number(num) + 1);
      } else if (parentNum == 4) {
        shopTheRoomMobileSlider4.slideTo(Number(num) + 1);
      } else if (parentNum == 5) {
        shopTheRoomMobileSlider5.slideTo(Number(num) + 1);
      } else if (parentNum == 6) {
        shopTheRoomMobileSlider6.slideTo(Number(num) + 1);
      } else if (parentNum == 7) {
        shopTheRoomMobileSlider7.slideTo(Number(num) + 1);
      } else if (parentNum == 8) {
        shopTheRoomMobileSlider8.slideTo(Number(num) + 1);
      } else if (parentNum == 9) {
        shopTheRoomMobileSlider9.slideTo(Number(num) + 1);
      } else if (parentNum == 10) {
        shopTheRoomMobileSlider10.slideTo(Number(num) + 1);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !window.DesignMode) return;
  try {
    
const testimonialsSlider = new Swiper('.testimonials-slider__container', {
  slidesPerView: 1.15,
  loop: true,
  spaceBetween: 20,
  centeredSlides: true,
  breakpoints: {
    769: {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: '.testimonials-slider__buttons .swiper-button-next',
        prevEl: '.testimonials-slider__buttons .swiper-button-prev',
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !window.DesignMode) return;
  try {
    
  $('.video-section__video-overlay').click(function() {
    $(this).hide();
    $(this).siblings('video').trigger('play');
  });

  } catch(e) { console.error(e); }
})();
})();
